import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Assuming this is where `container` is used
const container = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

